// extracted by mini-css-extract-plugin
export default {"root":"ErrorPage_root__ENMbl","label":"ErrorPage_label__QHOjw","title":"ErrorPage_title__WYeXR","description":"ErrorPage_description__nJRrM"};